// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-modal',
    // #endregion
    // #region Properties
    props: {
        window: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Data
    data: () => ({
        _windowID: ""
    }),
    // #endregion
    // #region Constructor
    mounted() {
        //ID
        this._windowID = "__window__" + utils.createId();
        //Args
        let tWindows = {
            name: this._windowID,
            variant: this.window.navigation.mode,
            size: this.window.navigation.size,
            position: this.window.navigation.location,
            window: this.window
        };
        //Show
        this.$appHost.notification.showModal2(this.$appHost.components.getComponent("g-entity-popup"), { window: this.window, }, tWindows);
    },
    beforeUnmount() {
        //Close
        this.$appHost.notification.closeModal(this._windowID);
        //ID
        this._windowID = "";
    },
    // #endregion
    // #region Watch
    watch: {
        "window"(value) {
            if (value && this._windowID) {
                //Args
                let tWindows = {
                    name: this._windowID,
                    variant: this.window.navigation.mode,
                    size: this.window.navigation.size,
                    position: this.window.navigation.location,
                    window: this.window
                };
                this.$appHost.notification.updateModal(this._windowID, { window: this.window, }, tWindows);
            }
        },
    },
    // #endregion
});
// #endregion
